module.exports = __webpack_public_path__ + "static/media/mefaLogosvg.39241b6b.svg";